import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { PathParticipantSteps, PathParticipantSummary } from '.';

import type { GetPathParticipantsRes } from 'shared-types/responses';

interface Props {
  userId: number;
}

const PathParticipant = ({ userId }: Props) => {
  const {
    pageState: { path }
  } = useReduxState();

  const { data, loading, updateData } = useApiData<GetPathParticipantsRes>({
    url: `/admin/paths/${path.id}/participants?userId=${userId}`,
    onlyIf: Boolean(userId)
  });

  return (
    <div className="user">
      <div className="summary">
        <PathParticipantSummary loading={loading} targetUser={data?.users[0]} />
      </div>

      <div className="steps">
        <PathParticipantSteps
          steps={data?.steps}
          progressData={data?.users[0]?.progressData}
          deadlines={data?.users[0]?.deadlines}
          loading={loading}
          userSettings={data?.users[0]?.userSettings}
          showAdminOptions={true}
          targetUser={data?.users[0]}
          updateData={updateData}
        />
      </div>

      <style jsx>{`
        .steps {
          margin-top: 20px;
        }
      `}</style>
    </div>
  );
};

export default PathParticipant;
